module.exports = __webpack_public_path__ + "img/asterisk.8365debe.svg";